import { render, staticRenderFns } from "./SGPTabsMenuHorizontalComponent.vue?vue&type=template&id=6faf3e41"
import script from "./SGPTabsMenuHorizontalComponent.vue?vue&type=script&lang=js"
export * from "./SGPTabsMenuHorizontalComponent.vue?vue&type=script&lang=js"
import style0 from "./SGPTabsMenuHorizontalComponent.vue?vue&type=style&index=0&id=6faf3e41&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports